import React, {Component} from 'react';
import {connect} from 'react-redux';
import ChecksList from "../ChecksList";
import CreditCardsList from "../CreditCardsList";
import classNames from "classnames";
import PropTypes from 'prop-types';
import {getCanUseChecks, getSelectedPrimaryAccount} from "../../invoice/Selectors";

export class PaymentCardLists extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showCards: true,
    };
    this.showCards = this.showCards.bind(this);
    this.showChecks = this.showChecks.bind(this);
  }
  showCards(){
    this.setState({showCards: true});
    this.props.onTabChange('CC');
  }
  showChecks(){
    this.setState({showCards: false});
    this.props.onTabChange('EC');
  }
  render() {
    return <div>
      <div className={"payment-type-tab-container"}>
        <div className={classNames("payment-type-tab", {"active": this.state.showCards})} onClick={this.showCards}>My Cards</div>
        {this.props.canUseChecks && <div className={classNames("payment-type-tab", {"active": !this.state.showCards})} onClick={this.showChecks}>My eChecks</div>}
      </div>
      <div>
        {this.state.showCards ?
          <CreditCardsList onEdit={this.props.onEdit} onDelete={this.props.onDelete}/> :
          <ChecksList onEdit={this.props.onEdit} onDelete={this.props.onDelete}/>
        }
      </div>
    </div>
  }

}

PaymentCardLists.propTypes = {
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
};

export default connect((state, props) => {
  return {
    selectedPrimaryAccount: getSelectedPrimaryAccount(state),
      canUseChecks: state.app.paymentMethods && state.app.paymentMethods.includes('EC'),
  }
})(PaymentCardLists);
